import palette from '@theme/assets/palette';
import fonts from '../assets/fonts';

const standardVariant = {
    field: {
        borderColor: palette.ui01,
        color: palette.black,
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 4,
        outline: 'none',
        ...fonts.input,
        _hover: {
            borderColor: palette.black,
        },
        _focus: {
            borderColor: palette.black,
            boxShadow: 'none',
            outline: 'none',
        },
        _placeholder: {
            color: palette.ui03,
        },
        _invalid: {
            outlineWidth: '1px',
            outlineOffset: '0',
            outlineColor: 'red',
        },
    },
};

export const input = {
    sizes: {},
    defaultProps: {},
    variants: {
        standard: standardVariant,
        compact: {
            field: {
                ...standardVariant.field,
                borderWidth: 0,
            },
        },
    },
};
